import { TypographySize } from '../../Typography';

export enum AvatarType {
  img = 'img',
  name = 'name',
  title = 'title',
  count = 'count'
}

export enum AvatarSize {
  xxs = 'xxs',
  xs = 'xs',
  s = 's',
  sm = 'sm',
  m = 'm',
  lg = 'lg',
  l = 'l'
}

export enum AvatarBorderSize {
  xs = 'xs',
  s = 's'
}

export enum AvatarBorderPosition {
  right = 'right',
  left = 'left',
  full = 'full'
}

export enum AvatarBorderColor {
  white = 'white',
  main = 'main'
}

export enum AvatarColor {
  main = 'main',
  secondary = 'secondary'
}

export type AvatarProps = {
  className?: string;
  size?: AvatarSize;
  type?: AvatarType;
  content: string;
  border?: {
    color?: AvatarBorderColor;
    size?: AvatarBorderSize;
    position?: AvatarBorderPosition;
  };
  color?: AvatarColor;
};

export const mapAvatarSizeToFontSize: Record<AvatarSize, TypographySize> = {
  [AvatarSize.xxs]: TypographySize.xxs,
  [AvatarSize.xs]: TypographySize.xs,
  [AvatarSize.s]: TypographySize.s,
  [AvatarSize.sm]: TypographySize.m,
  [AvatarSize.m]: TypographySize.m,
  [AvatarSize.lg]: TypographySize.l,
  [AvatarSize.l]: TypographySize.m
};
